import { IconButton, Spinner } from 'office-ui-fabric-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { MaxLengths } from '../../../data/MaxLenghts';
import { EUITextField } from '../../EUI/EUITextField';

/*
************************************************************************************************************************************
PROPS :
    ATTRIBUTS :
        bool    estOnline               détermine si utilisateur connecté au serveur ou non
        bool    messageEnCoursDEnvoi    détermine si message en cours de traitement par le serveur
        object  messageSelectionne      message parent, sélectionné dans l'optique d'y apporter une réponse
    METHODES :
        void    onSubmit(message)       méthode appelée lorsque l'utilisateur valide l'envoi d'un message
        void    onDeselectionMessage    méthode appelée lorsque l'utilisateur décide de ne plus répondre à un message en particulier
************************************************************************************************************************************
*/

class UserInput extends Component {

    _styles = {
        textfield: {
            fieldGroup: {
                background: "lightgrey",
                height: "150px"
            }
        },
        infoContainer: {
            root: {
                alignItems: "center",
                backgroundColor: "#f4f7f9",
                color: "#565867",
                padding: "3px 10px",
            }
        },
        smallIconButton: { icon: { fontSize: "10px" } },
        iconButton: {
            root: { selectors: { ":disabled": { backgroundColor: "inherit" } } },
            icon: {
                fontSize: "25px",
                selectors: { ".is-disabled &": { color: "lightgray" } }
            }
        },
        messageBar: {
            dismissal: {
                height: "auto",
                margin: "10px 16px 10px 0px"
            },
            iconContainer: { margin: "10px 0px 10px 16px" },
            text: { margin: "10px 8px" },
        },
        spinner: { root: { width: "32px" } }
    };

    constructor() {
        super();
        this.inputRef = React.createRef();
        this.objetState = {
            errorMessage: "",
            fileData: "",
            fileName: "",
            texte: ""
        };
        this.state = { ...this.objetState };
        this.fileUploadRef = React.createRef();
    };

    _masquerMessageBar = () => {
        this.setState({ errorMessage: "" });
    };

    _onChange = (event, newValue) => {
        this.setState({ texte: newValue });
    };

    _onSelectionFichier = (event) => {
        const MAX_FILE_SIZE = 3;
        const fichier = event.target.files[0];
        const fsize = Math.ceil((fichier.size / 1024 / 1024));
        if (fsize <= MAX_FILE_SIZE) {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                this._masquerMessageBar();
                this.setState({
                    fileData: Scriba.fichier().ByteArrayVersBase64(reader.result),
                    fileName: fichier.name
                });
            })
            reader.readAsArrayBuffer(fichier);
        } else {
            this._retirerFichier();
            this.setState({ errorMessage: `Document trop volumineux (${MAX_FILE_SIZE} Mo max.)` });
        }
    };

    _onKeyPress = (event) => {
        if (event.key === "Enter" && event.ctrlKey && !this._estBoutonEnvoyerDesactive()) {
            this._envoyerMessage();
        };
    };

    _retirerFichier = () => {
        this.setState({
            fileData: "",
            fileName: ""
        });
    };

    _selectionnerFichier = () => {
        this.fileUploadRef.current && this.fileUploadRef.current.click()
    };

    _estBoutonEnvoyerDesactive = () => {
        const { fileName, texte } = { ...this.state };
        return !this.props.estOnline
            || !(texte || fileName);
    };

    _envoyerMessage = () => {
        const { fileData, fileName, texte } = { ...this.state };

        if (texte || fileName) {
            let message = {
                texte: texte,
                fileName: "",
                fileData: ""
            };
            if (!!fileData && fileName) {
                message.fileData = fileData;
                message.fileName = fileName;
            };
            this.setState(
                this.objetState,
                this.props.onSubmit(message)
            );
        }
    };

    componentDidUpdate = (prevProps) => {
        if (this.props.messageSelectionne) { // Focus sur zone de saisie si réponse à un message
            if (prevProps.messageSelectionne && this.props.messageSelectionne.idMessage !== prevProps.messageSelectionne)
                this.inputRef.focus();
            else if (!prevProps.messageSelectionne)
                this.inputRef.focus();
        }
    };

    render = () => {
        return <Fragment>
            {this.state.errorMessage &&
                <MessageBar
                    dismissButtonAriaLabel="Fermer"
                    isMultiline={false}
                    onDismiss={this._masquerMessageBar}
                    messageBarType={MessageBarType.error}
                    styles={this._styles.messageBar}
                >
                    {this.state.errorMessage}
                </MessageBar>
            }
            {this.props.messageSelectionne &&
                <Stack horizontal styles={this._styles.infoContainer} gap={5}>
                    <Icon iconName="Reply" styles={this._styles.smallIconButton} />
                    <Stack.Item grow>
                        Vous répondez à ce message : {this.props.messageSelectionne.texte}
                    </Stack.Item>
                    <IconButton
                        ariaLabel="Annuler la réponse à un message"
                        iconProps={{ iconName: "ChromeClose" }}
                        onClick={this.props.onDeselectionMessage}
                        styles={this._styles.smallIconButton}
                        title="Annuler"
                    />
                </Stack>

            }
            {this.state.fileName &&
                <Stack horizontal styles={this._styles.infoContainer} gap={5}>
                    <Icon iconName="OpenFile" styles={this._styles.smallIconButton} />
                    <Stack.Item grow>
                        Pièce jointe : {this.state.fileName}
                    </Stack.Item>
                    <IconButton
                        ariaLabel="Retirer la pièce jointe"
                        iconProps={{ iconName: "ChromeClose" }}
                        onClick={this._retirerFichier}
                        styles={this._styles.smallIconButton}
                        title="Retirer la pièce jointe"
                    />
                </Stack>

            }
            <Stack horizontal verticalAlign="top">
                <Stack.Item grow>
                    <EUITextField
                        afficherNbCaracteresRestants={false}
                        autoComplete="off"
                        borderless
                        componentRef={(input) => { this.inputRef = input; }}
                        maxLength={MaxLengths.message.texte}
                        multiline
                        onChange={this._onChange}
                        onKeyUp={this._onKeyPress}
                        placeholder="Votre message..."
                        styles={this._styles.textfield}
                        value={this.state.texte}
                    />
                </Stack.Item>
                <Stack horizontal>
                    <input type="file" ref={this.fileUploadRef} onChange={this._onSelectionFichier} style={{ display: "none" }} />
                    <IconButton
                        ariaLabel="Joindre un fichier"
                        iconProps={{ iconName: "Attach" }}
                        onClick={this._selectionnerFichier}
                        styles={this._styles.iconButton}
                        title="Joindre un fichier"
                    />
                    {this.props.messageEnCoursDEnvoi ?
                        <Spinner styles={this._styles.spinner} /> :
                        <IconButton
                            ariaLabel="Envoyer"
                            disabled={this._estBoutonEnvoyerDesactive()}
                            iconProps={{ iconName: "Send" }}
                            onClick={this._envoyerMessage}
                            styles={this._styles.iconButton}
                            title="Envoyer"
                        />
                    }
                </Stack>
            </Stack>
        </Fragment>
    };

}

UserInput.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default UserInput;